var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgParticipantMuteCamera = function SvgParticipantMuteCamera(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#1A2023",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_195_82043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4922 13.0393C22.4381 13.0109 22.3772 12.9974 22.3158 13.0003C22.2545 13.0032 22.1952 13.0225 22.1442 13.056L19.9591 14.4884V12.8887C19.9591 12.6824 19.8757 12.4846 19.7274 12.3387C19.579 12.1928 19.3778 12.1108 19.168 12.1108H10.127C9.91721 12.1108 9.716 12.1928 9.56764 12.3387C9.41928 12.4846 9.33594 12.6824 9.33594 12.8887V19.1119C9.33594 19.3182 9.41928 19.5161 9.56764 19.662C9.716 19.8079 9.91721 19.8898 10.127 19.8898H19.168C19.3778 19.8898 19.579 19.8079 19.7274 19.662C19.8757 19.5161 19.9591 19.3182 19.9591 19.1119V17.5122L22.1442 18.9452C22.1952 18.9788 22.2546 18.998 22.316 19.0009C22.3773 19.0038 22.4383 18.9903 22.4925 18.9618C22.5466 18.9332 22.5918 18.8908 22.6233 18.8389C22.6549 18.7871 22.6714 18.7278 22.6714 18.6674V13.3333C22.6713 13.2729 22.6547 13.2137 22.6231 13.1619C22.5916 13.1102 22.5463 13.0678 22.4922 13.0393ZM19.281 19.1119C19.281 19.1414 19.2691 19.1697 19.2479 19.1905C19.2267 19.2114 19.198 19.2231 19.168 19.2231H10.127C10.097 19.2231 10.0683 19.2114 10.0471 19.1905C10.0259 19.1697 10.014 19.1414 10.014 19.1119V12.8887C10.014 12.8593 10.0259 12.831 10.0471 12.8102C10.0683 12.7893 10.097 12.7776 10.127 12.7776H19.168C19.198 12.7776 19.2267 12.7893 19.2479 12.8102C19.2691 12.831 19.281 12.8593 19.281 12.8887V19.1119ZM21.9933 18.0445L19.9591 16.711V15.2897L21.9933 13.9561V18.0445Z",
    fill: "#1A2023"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.2128,
    y1: 9.70912,
    x2: 21.3148,
    y2: 21.7482,
    stroke: "#1A2023",
    strokeWidth: 0.555642
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "white",
    strokeOpacity: 0.16
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_195_82043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3354,
    height: 13.3354,
    fill: "white",
    transform: "translate(9.33594 9.33228)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgParticipantMuteCamera);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "participant-mute-camera.e241a6b090cd76c3069fe4dcc337dfbb.svg";